var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.63398 0.999999C6.01888 0.333333 6.98112 0.333333 7.36603 1L12.5622 10C12.9471 10.6667 12.466 11.5 11.6962 11.5H1.30385C0.534047 11.5 0.0529221 10.6667 0.437822 10L5.63398 0.999999Z","fill":"white"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }